import React from 'react';
import isEmpty from 'lodash.isempty';
import PropTypes from 'prop-types';
import { getWordClassName, getBracket } from '../../../../utils/shared/probeDetailUtils';

const OralReadingWord = props => {
    const {
        word,
        isSelfCorrected,
        isIncorrect,
        isLastSelected,
        notIncludedInScore,
        selfCorrectedMark,
    } = props;
    const wordClassName = getWordClassName(isSelfCorrected, isIncorrect, null, notIncludedInScore);
    const bracket = getBracket(isLastSelected);

    if (isEmpty(wordClassName)) {
        return (
            <>
                {word} {bracket}
            </>
        );
    }
    return (
        <>
            <span className={wordClassName}>
                {word}
                {isSelfCorrected ? <span className="sc">{selfCorrectedMark}</span> : null}
            </span>{' '}
            {bracket}
        </>
    );
};

OralReadingWord.defaultProps = {
    word: '',
    isSelfCorrected: false,
    isIncorrect: false,
    notIncludedInScore: false,
    isLastSelected: false,
    selfCorrectedMark: 'sc',
};

OralReadingWord.propTypes = {
    word: PropTypes.string,
    isSelfCorrected: PropTypes.bool,
    isIncorrect: PropTypes.bool,
    notIncludedInScore: PropTypes.bool,
    isLastSelected: PropTypes.bool,
    selfCorrectedMark: PropTypes.string,
};

export default OralReadingWord;
